module.exports = __webpack_public_path__ + "static/img/6.6a6749a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/6.svg
// module id = 702
// module chunks = 1